const formatNumberToDecimalPlaces = (number: number, decimalPlaces = 2) => {
  const multiplier = Math.pow(10, decimalPlaces);
  const formattedNumber = (Math.floor(number * multiplier) / multiplier).toFixed(decimalPlaces);
  return formattedNumber;
};

export const currencyConvertor = (number: number, decimalPlaces = 0): string | null | undefined => {
  if (number) {
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let suffixIdx = 0;

    while (number >= 1000 && suffixIdx < suffixes.length - 1) {
      number /= 1000.0;
      suffixIdx += 1;
    }

    return `$${formatNumberToDecimalPlaces(number, decimalPlaces)}${suffixes[suffixIdx]}`;
  }
};
